import { MaskedInput, MaskedInputProps } from "react-text-mask-modern";
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

export interface NumberMaskOptions {
    prefix: string;
    suffix: string;
    includeThousandsSeparator: boolean;
    thousandsSeparatorSymbol: string;
    allowDecimal: boolean;
    decimalSymbol: string;
    decimalLimit: number;
    requireDecimal: boolean;
    allowNegative: boolean;
    allowLeadingZeroes: boolean;
    integerLimit: number | null;
}

interface Props extends Omit<MaskedInputProps, 'mask'> {
    integerLimit?: number | null;
    decimalLimit: number; 
    onValueChange?: (value?: string) => void;
}

export function DecimalMaskedInput({ integerLimit, decimalLimit, placeholder, value, onValueChange, ...rest }: Props) {
    const mask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        includeThousandsSeparator: false,
        integerLimit,
        decimalLimit
    });

    return <MaskedInput
        {...rest}
        mask={mask}
        value={value}
        placeholder={placeholder}
    />
}
